import { render, staticRenderFns } from "./wy-analytics-compare-metrics-cal-b.vue?vue&type=template&id=a8319be2&"
import script from "./wy-analytics-compare-metrics-cal-b.vue?vue&type=script&lang=js&"
export * from "./wy-analytics-compare-metrics-cal-b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports